import { ConfirmDialogData } from '../../base-confirm-dialog/confirm-dialog-data.interface';

export interface ConfirmByInputDialogData extends ConfirmDialogData {
  confirmPhrase: string;
}
